// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"54cd92c9","127":"9d51f797","322":"c312f477","362":"b57940a2","453":"d4d8fcc2","556":"3d9a9794","573":"6a06ecd3","776":"c6b9382d","911":"1cb566c9","939":"e385f427","940":"e3d7b306","961":"7c077c74"}[chunkId] + ".chunk.js";
};